import React, {Fragment} from 'react';

import b_ from 'b_';
import times from 'lodash/times';
import InfiniteScroll from 'react-infinite-scroller';
import useWindowSize from 'react-use/lib/useWindowSize';

import {isSurveyItem} from 'client/common/store/reducers/surveys/types';
import {Device} from 'client/common/utils/device-width';

import {useDevice} from 'client/common/hooks/device';
import {useIsSuper} from 'client/common/hooks/user';

import SurveyCard from 'client/quicksurvey/list/components/survey-card';
import SurveyCardSkeleton from 'client/quicksurvey/list/components/survey-card-skeleton';

import {ListComponentProps} from './types';

import './survey-list.css';

const b = b_.with('survey-list');

const SKELETON_COUNTS = {
    [Device.Mobile]: 3,
    [Device.Tablet]: 6,
    [Device.Desktop]: 12,
    [Device.Widescreen]: 12
};

function CardLoader() {
    const device = useDevice();

    const skeletonCount = SKELETON_COUNTS[device];

    return (
        <Fragment>
            {times(skeletonCount, index => (
                <SurveyCardSkeleton key={`skeleton-${index}`} />
            ))}
        </Fragment>
    );
}

export default function Grid(props: ListComponentProps) {
    const {categories, interests, isEntirelyLoaded, list, segments, loadMore} = props;

    const {height} = useWindowSize();
    const isSuper = useIsSuper();

    return (
        <InfiniteScroll
            className={b('items', {type: 'grid'})}
            hasMore={!isEntirelyLoaded}
            loader={<CardLoader key='card-loader' />}
            loadMore={loadMore}
            threshold={height * 2}
        >
            {list.map((item, index) => (
                <SurveyCard
                    categories={categories}
                    interests={interests}
                    key={isSurveyItem(item) ? item.slug : index}
                    segments={segments}
                    survey={item}
                    isSuper={isSuper}
                />
            ))}
        </InfiniteScroll>
    );
}
